import * as React from 'react';
import { ArticleHeading1, InlineText1, InlineText2 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';
import { IConstructionProgressImage } from '../../types/newbuilding/constructionProgress';
import { Link } from '../Link';
import { VerticalSlider } from '../VerticalSlider';

interface IConstructionProgressProps {
  newbuildingName: string;
  updated: string;
  images: IConstructionProgressImage[];
  url: string;
  onLinkClick(): void;
  onItemClick(index: number): void;
}

export function ConstructionProgress({
  newbuildingName,
  updated,
  images,
  url,
  onLinkClick,
  onItemClick,
}: IConstructionProgressProps) {
  return (
    <div id="building-process" data-nav-tab="building-process/Ход строительства" className={styles['nav_container']}>
      <div className={styles['container']}>
        <div className={styles['block']}>
          <Link url={url} target={'blank'} onClick={onLinkClick}>
            <ArticleHeading1 as={'h2'} color="text-primary-default">
              Ход строительства {newbuildingName}
            </ArticleHeading1>
          </Link>
        </div>
        <InlineText2 color="text-primary-default">{updated}</InlineText2>
        <div className={styles['album']}>
          <VerticalSlider containerClass={styles['slider']} onItemClick={onItemClick}>
            {images.map(({ text, thumbnailUrl }) => (
              <div key={text} className={styles['image']} style={{ backgroundImage: `url(${thumbnailUrl})` }} />
            ))}
          </VerticalSlider>
        </div>
        <Link url={url} onClick={onLinkClick} target="blank">
          <InlineText1 color="text-main-default">Смотреть все альбомы</InlineText1>
        </Link>
      </div>
    </div>
  );
}
